import { defineComponent as _defineComponent } from 'vue'
import { useLazyAsyncData, useNuxtApp } from '#app'
import { nextTick, onMounted, Ref, ref } from 'vue'
import { getFooterSeoLinks } from './fetch'


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterSeoLinks',
  setup(__props) {

const activeItem = ref(0)
const tabsScrolled = ref(false)
const tabs: Ref<HTMLElement | null> = ref(null)
const { $route } = useNuxtApp()
const { data: footerData } = useLazyAsyncData(
  `footerSeoLinks-${$route.params.lang || 'en-gb'}`,
  () => {
    const { $puLangFetch, $route } = useNuxtApp()
    return getFooterSeoLinks($route.params.lang || 'en-gb', $puLangFetch)
  },
)

onMounted(() => {
  tabs.value = document.querySelector('[data-seo-tabs-js]') as HTMLElement
})

function isActive(menuItem: number) {
  return activeItem.value === menuItem
}

function setActiveTab(activeTab: number) {
  activeItem.value = activeTab
}

function tabsScrolledHandler(isVisible: boolean) {
  tabsScrolled.value = !isVisible
}

function scrollForward() {
  if (tabs.value) {
    nextTick(() => {
      tabs.value!.scrollLeft += 60
    })
  }
}

function scrollBack() {
  if (tabs.value) {
    nextTick(() => {
      tabs.value!.scrollLeft -= 60
    })
  }
}

return { __sfc: true,activeItem, tabsScrolled, tabs, $route, footerData, isActive, setActiveTab, tabsScrolledHandler, scrollForward, scrollBack }
}

})